export default "__VITE_ASSET__BlhA4Jem__"